import { AxiosResponse } from "axios";
import React from "react";
import * as urls from "../../../Urls";
import $ from "jquery";

import { IContentBoxTabTableProps } from "../../../../intelws_portal/bundles/ContentBoxTabTable";
import ContentBoxTabTable from "../../../../intelws_portal/bundles/ContentBoxTabTable";
import Loading from "../../../../intelws_portal/constructs/elements/Loading";
import { IDataRepr } from "../../../../intelws_portal/constructs/elements/Table";
import { ITabRepr } from "../../../../intelws_portal/constructs/elements/Tabs";
import AddButton from "../../../../intelws_portal/constructs/elements/AddButton";
import { get, getCancelToken, post } from "../../../../intelws_portal/utils/backendInterface";

import { IPageComponentProps } from "../../../../declarations/common";
import { getBundledAlertsUI } from "../../../../declarations/common_utils";
import ModalManualTask from "../../modal/ModalManualTask"
import { confirm } from "../../../../intelws_portal/constructs/elements/WindowConfirm";

interface IMatchProps {
    userId: string
}

interface IFetchManualTaskConfig extends AxiosResponse {
    data: {
        tab_config: ITabRepr[],
        access_keys: string[][],
        column_names: string[][],
        years: number[],
        is_project_add: boolean
    }
}

interface IFetchManualTask extends AxiosResponse {
    data: {
        data: IDataRepr[],
    }
}

interface IClientProjectProps<T> extends IPageComponentProps<T> {
    mutator?: {
        currentPage?: (currentPage: string) => void,
        bnsDocCallback?: (data: IDataRepr[]) => void
    },
    bnsValues?: number[],
    bnsShow?: string[]
}

function ClientProject(props: IClientProjectProps<IMatchProps>) {
    const ENDPOINT = "/api/manualtasklist/";
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [isProjectAdd, setIsProjectAdd] = React.useState(false);
    const [accessKeys, setAccessKeys] = React.useState<string[][]>([]);
    const [columnNames, setColumnNames] = React.useState<string[][]>([]);

    const cancelTokenSource = React.useRef(getCancelToken());
    const [tabConfig, setTabConfig] = React.useState<ITabRepr[]>([]);
    const [currTab, setCurrTab] = React.useState(0);

    const [years, setYears] = React.useState<number[]>([]);
    const [currYear, setCurrYear] = React.useState(-1);

    const [success, setSuccess] = React.useState<string[]>([]);
    const [fail, setFail] = React.useState<string[]>([]);

    const getAllYearText = React.useRef("Select Year");

    const [tableData, setTableData] = React.useState<(IDataRepr[] | undefined)[]>([]);

    const displayData = React.useMemo(() => {
        return tableData.map(currData => {
            if (currData == undefined) {
                return currData;
            }

            if (currYear == -1) {
                return currData;
            }

            return currData.filter(currRow => {
                const createdDate = new Date(currRow["tt_create_time_iso"] as string);
                return createdDate.getFullYear() == currYear
            })
        })
    }, [tableData, currYear])

    React.useEffect(() => {
        if (props.mutator != undefined && props.mutator.currentPage != undefined) {
            props.mutator.currentPage("ClientProject");
        }
        let queryParams = {
            section: "manual_task_list_client_config",
            user_id: props.match.params.userId
        }
        const configRequestResponse = get(ENDPOINT, cancelTokenSource.current.token, queryParams) as Promise<IFetchManualTaskConfig>;
        configRequestResponse.then((configResponse) => {
            setTabConfig(configResponse.data.tab_config);
            let queryParams = {
                section: "manual_task_list_client",
                type: configResponse.data.tab_config[0].target,
                user_id: props.match.params.userId
            }
            const dataResponseRequest = get(ENDPOINT, cancelTokenSource.current.token, queryParams) as Promise<IFetchManualTask>;
            dataResponseRequest.then((dataResponse) => {
                setTableData(() => {
                    let newTableData = new Array(configResponse.data.tab_config.length).fill(undefined);
                    newTableData[0] = [...dataResponse.data.data];
                    return newTableData;
                })
                setAccessKeys(configResponse.data.access_keys);
                setColumnNames(configResponse.data.column_names);
                setIsProjectAdd(configResponse.data.is_project_add);
                setYears(configResponse.data.years);
                setCurrYear(configResponse.data.years[0]);
                setIsLoaded(true);
            })
        })
        return () => {
            cancelTokenSource.current.cancel();
        }
    }, [])

    function tabCallback(tabName: string, index: number, prevIndex: number) {
        setCurrTab(index);
        if (tableData[index] == undefined || tabName == "project_templates") {
            let queryParams = {
                section: "manual_task_list_client",
                type: tabName,
                user_id: props.match.params.userId
            }
            const responseRequest = get(ENDPOINT, cancelTokenSource.current.token, queryParams) as Promise<IFetchManualTask>;
            responseRequest.then((response) => {
                setTableData((prevTableData) => {
                    let newTableData = [...prevTableData];
                    newTableData[index] = [...response.data.data];
                    return newTableData;
                })
            })
        }
    }

    function addToTable(data?: IDataRepr, section?: string, success?: string[], fail?: string[]) {
        if (data != undefined && section != undefined) {
            setTableData((prevTableData) => {
                let newTableData = [...prevTableData];
                let currIndex = tabConfig.findIndex((ele) => {
                    return ele.target == section;
                })
                if (currIndex > -1) {
                    let currTable = newTableData[currIndex];
                    if (currTable != undefined) {
                        newTableData[currIndex] = [...currTable, data];
                    }
                }
                return newTableData;
            })
        }
        if (success != undefined && fail != undefined) {
            setSuccess(success);
            setFail(fail);
        }
    }

    function inputCallback(rowIndex: number, accessKey: string, value?: boolean | string | HTMLCollectionOf<HTMLOptionElement>) {
        let absoluteRowIndex = -1;
        let currTable = tableData[currTab];
        let displayTable = displayData[currTab];
        if (currTable != undefined) {
            absoluteRowIndex = currTable.findIndex((ele) => {
                if (displayTable != undefined) {
                    return ele.id == displayTable[rowIndex].id
                }
            })
        }
        if (typeof value == "string") {
            if (value == "delete") {
                confirm("Are you sure you want to delete this file?").then(() => {
                    let queryParams = {
                        section: "manual_task_or_template_delete",
                        user_id: props.match.params.userId,
                    }
                    let formData = new FormData();
                    if (currTable != undefined) {
                        formData.append("task_tracking_id", currTable[absoluteRowIndex].id.toString());
                        const requestResponse = post(ENDPOINT, formData, cancelTokenSource.current.token, queryParams);
                        requestResponse.then(() => {
                            setTableData((prevTableData) => {
                                let newTableData = [...prevTableData];
                                let currTable = newTableData[currTab];
                                if (currTable != undefined) {
                                    newTableData[currTab] = currTable.filter((ele, loopIndex) => loopIndex !== absoluteRowIndex);
                                }
                                return newTableData;
                            })
                        })
                    }
                })
            }
        }
    }

    function getContent() {
        let link = {
            tt_task_name: {
                baseUrl: urls.BASE_MANUAL_TASK_DETAILS,
                urlParams: ['tt_user_id', 'id'],
            }
        };


        const yearDropdownConfigs = tabConfig.map(tabEle => {
            return {
                target: tabEle.target,
                dropdowns: [
                    {
                        value: currYear,
                        options: [getAllYearText.current, ...years.map(year => year.toString())],
                        values: [-1, ...years],
                        callback: (value: string) => {
                            setCurrYear(parseInt(value))
                        }
                    }
                ]
            }
        })

        let miscHeaders = undefined;
        if (isProjectAdd) {
            miscHeaders = <AddButton buttonValue={<i className="fa fa-plus"></i>}
                onClick={() => { $('#manualTaskAddModal').modal('show'); }} />;
        }

        let propObject: IContentBoxTabTableProps = {
            tabs: tabConfig,
            contents: displayData,
            columnNames: columnNames,
            accessKeys: accessKeys,
            title: "Projects",
            miscHeaders: miscHeaders,
            hasSearch: true,
            hasRecords: true,
            tabCallback: tabCallback,
            inputCallback: inputCallback,
            dropdowns: yearDropdownConfigs,
            links: new Array(tabConfig.length).fill(link)
        };
        return (<ContentBoxTabTable {...propObject} />)
    }

    if (!isLoaded) {
        return <Loading />
    } else {
        return (
            <div className="body-content-wrapper clearfix" style={{ paddingTop: "16px" }}>
                {getBundledAlertsUI(success, fail, setSuccess, setFail)}
                {getContent()}
                {(() => {
                    if (isProjectAdd && props.bnsValues != undefined && props.bnsShow != undefined && 
                            props.mutator != undefined && props.mutator.bnsDocCallback != undefined) {
                        return <ModalManualTask mutator={addToTable} userId={props.match.params.userId} 
                            bnsOptions={props.bnsShow} bnsValue={props.bnsValues} bnsDocCallback={props.mutator.bnsDocCallback} />
                    }
                })()}
            </div>
        )
    }
}

export default ClientProject;